export const Star = (props: React.SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			data-name="Layer 2"
			viewBox="0 0 67.04 67.04"
			width={16}
			height={16}
			{...props}
		>
			<path
				d="M33.52 0C15.01 0 0 15.01 0 33.52s15.01 33.52 33.52 33.52 33.52-15.01 33.52-33.52S52.03 0 33.52 0Zm15.09 38.34c-.64.62-.93 1.52-.78 2.39l2.15 12.56c.38 2.21-1.94 3.89-3.92 2.85l-11.28-5.93c-.79-.41-1.73-.41-2.52 0l-11.28 5.93c-1.98 1.04-4.3-.64-3.92-2.85l2.15-12.56a2.69 2.69 0 0 0-.78-2.39l-9.13-8.9c-1.6-1.56-.72-4.29 1.5-4.61L23.41 23c.88-.13 1.64-.68 2.04-1.48l5.64-11.43c.99-2.01 3.86-2.01 4.85 0l5.64 11.43c.39.8 1.16 1.35 2.04 1.48l12.61 1.83c2.22.32 3.1 3.05 1.5 4.61l-9.13 8.9Z"
				data-name="Layer 1"
				style={{
					fill: "#f7b119",
				}}
			/>
		</svg>
	);
};

export const FacebookLogo = (props: React.SVGProps<SVGSVGElement>) => {
	return (
		<svg
			id="Layer_2"
			data-name="Layer 2"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 11.35 21.89"
			className={`${props.className ?? ""}`}
			width="100%"
			height="100%"
			{...props}
		>
			<g id="Nav_Foot" data-name="Nav/Foot">
				<g id="Group_148" data-name="Group 148">
					<path
						id="Path_10994"
						data-name="Path 10994"
						d="m7.39,21.89v-10.01h3.09c.14,0,.24,0,.26-.19.15-1.21.31-2.41.46-3.61,0-.03,0-.06-.02-.09h-3.74s-.06-.06-.06-.08c0-.96-.04-1.92.02-2.88.05-.94.59-1.38,1.61-1.42.66-.02,1.31-.01,1.97-.02h.34c.01-.08.02-.17.03-.25,0-.99,0-1.98,0-2.97,0-.21-.05-.3-.27-.3-1.2-.01-2.41-.13-3.6-.04-2.21.15-3.96,1.94-4.07,4.15-.08,1.13-.05,2.27-.07,3.41v.37H0v3.9h3.31v10c-.1,0,4.98.02,4.08.02"
					/>
				</g>
			</g>
		</svg>
	);
};

export const LinkedInLogo = (props: React.SVGProps<SVGSVGElement>) => {
	return (
		<svg
			id="Layer_2"
			data-name="Layer 2"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 19.9 19"
			className={`${props.className ?? ""}`}
			width="100%"
			height="100%"
			{...props}
		>
			<g id="Nav_Foot" data-name="Nav/Foot">
				<g id="Group_149" data-name="Group 149">
					<g id="Group_137" data-name="Group 137">
						<path
							id="Path_10991"
							data-name="Path 10991"
							d="m0,19h3.64V5.23H0v13.76ZM0,3.37h3.64V0H0v3.37Z"
						/>
						<g id="Group_125" data-name="Group 125">
							<g id="Group_136" data-name="Group 136">
								<path
									id="Path_10992"
									data-name="Path 10992"
									d="m19.89,19h-3.64v-7.02c.05-.97-.03-1.93-.23-2.88-.14-.41-.4-.77-.75-1.02-.37-.25-.82-.37-1.27-.36-.61,0-1.2.17-1.7.52-.49.33-.85.81-1.03,1.37-.23,1.04-.33,2.1-.28,3.16v6.23h-3.64V5.23h3.38v2.02c1.53-2.12,4.33-2.91,6.74-1.89.59.23,1.11.62,1.51,1.11.34.45.59.97.71,1.53.16.81.22,1.63.2,2.45v8.55Z"
								/>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>
	);
};

export const YouTubeLogo = (props: React.SVGProps<SVGSVGElement>) => {
	return (
		<svg
			id="Layer_2"
			data-name="Layer 2"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 22.99 16.04"
			className={`${props.className ?? ""}`}
			width="100%"
			height="100%"
			{...props}
		>
			<g id="Nav_Foot" data-name="Nav/Foot">
				<g id="Group_151" data-name="Group 151">
					<g id="Group_131" data-name="Group 131">
						<g id="Group_139" data-name="Group 139">
							<path
								id="Path_10993"
								data-name="Path 10993"
								d="m22.99,5.91v4.17c-.02.17-.02.34-.05.51-.12.95-.19,1.92-.37,2.86-.23,1.17-1.17,2.07-2.35,2.23-.91.1-1.82.19-2.73.22-1.54.06-3.08.1-4.62.11-3.25.07-6.49-.02-9.73-.27-1.36-.05-2.5-1.04-2.75-2.38-.18-.89-.29-1.8-.34-2.71C-.01,9.36,0,8.05,0,6.75c-.02-1.39.11-2.78.39-4.14C.64,1.44,1.58.54,2.76.35c.9-.1,1.8-.19,2.7-.22,1.52-.06,3.05-.1,4.58-.11,3.27-.08,6.54.01,9.8.27,1.37.05,2.51,1.05,2.76,2.39.14.69.21,1.4.29,2.11.05.37.06.74.09,1.11m-14.45-1.92v7.58l7.29-3.78-7.29-3.8"
							/>
						</g>
					</g>
				</g>
			</g>
		</svg>
	);
};

export const TwitterLogo = (props: React.SVGProps<SVGSVGElement>) => {
	return (
		<svg
			id="Layer_2"
			data-name="Layer 2"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 277.5 283.04"
			className={`${props.className ?? ""}`}
			width="100%"
			height="100%"
			{...props}
		>
			<g id="Layer_1-2" data-name="Layer 1">
				<path d="m276.65,281.58c-2.06-3.01-4.14-6.02-6.21-9.03-3.9-5.68-7.79-11.37-11.69-17.04-4.12-5.98-8.26-11.95-12.38-17.93-5.37-7.79-10.71-15.6-16.08-23.39-4.4-6.39-8.83-12.77-13.23-19.16-5.23-7.59-10.42-15.2-15.65-22.78-6.72-9.73-13.48-19.44-20.19-29.18-4.1-5.95-8.13-11.94-12.22-17.89-1.14-1.67-2.17-3.42-3.62-5.01.24-.31.47-.64.74-.94,3.53-4.09,7.06-8.17,10.59-12.25,2.82-3.27,5.65-6.53,8.47-9.81,3.47-4.03,6.92-8.07,10.39-12.1,2.85-3.3,5.73-6.58,8.57-9.88,4.8-5.57,9.58-11.15,14.38-16.72,3.25-3.78,6.53-7.53,9.78-11.31,4.9-5.7,9.78-11.41,14.68-17.11,2.25-2.61,4.52-5.2,6.78-7.81,4.04-4.68,8.08-9.38,12.12-14.06,1.95-2.26,3.92-4.52,5.87-6.78.23-.27.59-.5.37-1.1-.33-.04-.72-.12-1.12-.14-1.66-.05-3.32-.12-4.98-.12-4.24-.02-8.48-.01-12.72,0-1.49,0-2.99.11-4.48.09-.92-.01-1.53.39-2.1,1.07-2.33,2.76-4.7,5.49-7.06,8.22-4.62,5.34-9.24,10.68-13.86,16.02-3.39,3.93-6.78,7.87-10.17,11.8-3.28,3.8-6.58,7.6-9.86,11.41-3.33,3.87-6.64,7.77-9.98,11.63-2.96,3.42-5.97,6.8-8.93,10.23-5.28,6.14-10.53,12.3-15.81,18.45-3.49,4.06-7,8.11-10.5,12.17-.72.84-1.41,1.7-2.18,2.63-.27-.35-.49-.59-.67-.85-2.77-3.99-5.54-7.97-8.3-11.97-5.02-7.28-10.04-14.55-15.05-21.84-5.22-7.59-10.42-15.2-15.65-22.78-5.18-7.52-10.38-15.02-15.57-22.54-5.09-7.38-10.17-14.77-15.25-22.15C83.33.16,82.24,0,80.81,0,56.07.04,31.33.03,6.59.02c-1.83,0-3.66.01-5.49.03-.35,0-.77-.12-1.1.54,11.94,17.31,23.96,34.72,35.93,52.16,12,17.49,24.05,34.93,36.09,52.4,12,17.42,24.01,34.83,36.04,52.29-.16.19-.31.38-.47.57-2.32,2.66-4.65,5.31-6.96,7.98-4.81,5.56-9.61,11.13-14.4,16.7-3.9,4.53-7.78,9.09-11.68,13.61-5.1,5.91-10.22,11.8-15.33,17.71-3.31,3.83-6.6,7.68-9.92,11.52-2.74,3.18-5.51,6.33-8.24,9.51-3.08,3.59-6.12,7.22-9.21,10.81-4.72,5.47-9.48,10.91-14.21,16.37-3.32,3.83-6.61,7.68-9.92,11.52-2.3,2.68-4.59,5.36-6.89,8.05-.26.3-.64.55-.55,1.19.37.01.77.04,1.17.04,2,0,3.99-.02,5.99-.02,5.49,0,10.98.02,16.47.04.59,0,1.09-.02,1.54-.55,1.89-2.26,3.84-4.47,5.77-6.71,3.31-3.84,6.61-7.68,9.91-11.52,2.71-3.15,5.43-6.29,8.13-9.44,2.82-3.27,5.61-6.56,8.43-9.83,1.93-2.23,3.89-4.43,5.81-6.67,2.46-2.87,4.86-5.78,7.33-8.64,3.23-3.74,6.51-7.43,9.74-11.18,2.47-2.86,4.85-5.79,7.32-8.66,4.31-5,8.67-9.96,12.99-14.95,4.92-5.69,9.8-11.4,14.71-17.09,1.17-1.36,2.35-2.72,3.55-4.12.61.84,1.22,1.67,1.81,2.52,3.89,5.63,7.78,11.27,11.66,16.91,4.59,6.67,9.17,13.34,13.75,20.01,8,11.62,16.01,23.24,24.01,34.86,4.61,6.7,9.22,13.41,13.84,20.1,3.04,4.41,6.16,8.76,9.13,13.22.87,1.3,1.81,1.72,3.34,1.72,14.55-.05,29.11-.02,43.66-.01,11.85,0,23.7.02,35.55.03.48,0,.97,0,1.61,0-.35-.61-.58-1.05-.85-1.45Zm-36.6-16.43c-6.9,0-13.8,0-20.71.03-3.66.01-7.31.06-10.97.1-.25,0-.5.01-.75,0-.79-.03-1.38-.31-1.86-1.02-2.07-3.06-4.19-6.09-6.31-9.11-4.36-6.22-8.73-12.43-13.09-18.65-3.72-5.3-7.42-10.61-11.13-15.92-3.54-5.07-7.08-10.14-10.63-15.2-3.57-5.1-7.16-10.19-10.73-15.28-5.38-7.68-10.76-15.37-16.14-23.05-5.33-7.61-10.67-15.22-16-22.84-3.38-4.83-6.73-9.68-10.11-14.5-3.48-4.96-6.97-9.91-10.47-14.86-1.15-1.62-2.37-3.2-3.53-4.82-.65-.91-1.21-1.89-1.84-2.81-2.22-3.21-4.46-6.4-6.7-9.6-4.26-6.09-8.52-12.17-12.79-18.25-4.72-6.73-9.43-13.45-14.15-20.18-6.45-9.21-12.91-18.42-19.35-27.64-2.5-3.57-4.96-7.16-7.45-10.74-.39-.57-.82-1.11-1.34-1.82.56-.03.92-.06,1.28-.06,11.43,0,22.87.01,34.3-.03.94,0,1.44.4,1.91,1.08,2.04,2.93,4.1,5.84,6.15,8.77,3.05,4.35,6.11,8.69,9.15,13.05,3.76,5.37,7.49,10.76,11.27,16.13,5.37,7.64,10.78,15.25,16.16,22.88,2.36,3.36,4.66,6.76,7.01,10.13,4.3,6.16,8.61,12.31,12.91,18.47,5.68,8.13,11.36,16.26,17.05,24.39,5.4,7.72,10.81,15.43,16.21,23.15,7.45,10.64,14.91,21.27,22.36,31.91,6.67,9.52,13.32,19.04,19.99,28.56,5.7,8.12,11.42,16.22,17.12,24.34,3.31,4.72,6.6,9.46,9.9,14.19,1.71,2.45,3.41,4.91,5.12,7.36.4.57.87,1.1,1.48,1.87-1.28,0-2.32,0-3.35,0Z" />
			</g>
		</svg>
	);
};
